/*
  Glass Hub: site-wide behaviour. Header, phone menu, cart count, toast, sections rising in,
  the morphing mirror in the home hero and the lit mirrors on product cards.
*/
(function () {
  'use strict';
  var GH = (window.GH = window.GH || {});
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var still = reduced || GH.motion === false;

  /* header: shadow once scrolled */
  var header = document.querySelector('[data-gh-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* phone menu */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-gh-open]');
    if (opener) {
      var drawer = document.getElementById(opener.getAttribute('data-gh-open'));
      if (drawer) {
        drawer.hidden = false;
        requestAnimationFrame(function () {
          drawer.classList.add('is-open');
        });
        opener.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('gh-locked');
        var close = drawer.querySelector('[data-gh-close].gh-iconbtn');
        if (close) close.focus();
      }
      return;
    }
    var closer = e.target.closest('[data-gh-close]');
    if (closer) {
      var d = closer.closest('[data-gh-drawer]');
      if (d) closeDrawer(d);
    }
  });
  function closeDrawer(d) {
    d.classList.remove('is-open');
    document.documentElement.classList.remove('gh-locked');
    var btn = document.querySelector('[data-gh-open="' + d.id + '"]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    setTimeout(function () {
      d.hidden = true;
    }, 260);
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('[data-gh-drawer].is-open');
    if (open) closeDrawer(open);
  });

  /* cart count and toast */
  GH.refreshCart = function () {
    return fetch((GH.routes ? GH.routes.cart : '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        document.querySelectorAll('[data-gh-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = !cart.item_count;
          el.classList.remove('is-pop');
          void el.offsetWidth;
          el.classList.add('is-pop');
        });
        return cart;
      })
      .catch(function () {});
  };
  var toastTimer;
  GH.toast = function (text, href, linkText) {
    var el = document.getElementById('GhToast');
    if (!el) return;
    el.innerHTML = '';
    var p = document.createElement('span');
    p.textContent = text;
    el.appendChild(p);
    if (href && linkText) {
      var a = document.createElement('a');
      a.href = href;
      a.textContent = linkText;
      el.appendChild(a);
    }
    el.hidden = false;
    requestAnimationFrame(function () {
      el.classList.add('is-on');
    });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-on');
      setTimeout(function () {
        el.hidden = true;
      }, 300);
    }, 4200);
  };

  /* sections rise in once */
  var risers = document.querySelectorAll('[data-gh-rise]');
  if (!still && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px' }
    );
    risers.forEach(function (el) {
      el.classList.add('gh-rise');
      io.observe(el);
    });
  }

  /* hero photo slides: fade between photos, dots that fill with time, arrows, swipe */
  function sliders() {
    document.querySelectorAll('[data-gh-slider]').forEach(function (root) {
      if (root.ghSlider) return;
      root.ghSlider = true;
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-gh-slide-item]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-gh-slide-dot]'));
      if (slides.length < 2) return;
      var seconds = Number(root.getAttribute('data-seconds')) || 0;
      var i = 0;
      var timer = null;
      var hold = false;
      root.style.setProperty('--gh-slide-time', seconds + 's');
      var show = function (n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, j) {
          s.classList.toggle('is-active', j === i);
        });
        dots.forEach(function (d, j) {
          d.classList.remove('is-active');
          if (j === i) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
          if (j === i) {
            void d.offsetWidth;
            d.classList.add('is-active');
          }
        });
        var num = root.querySelector('[data-gh-slide-num]');
        if (num) num.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
      };
      var play = function () {
        clearInterval(timer);
        if (!still && seconds > 0 && !hold && !document.hidden) {
          root.classList.remove('is-held');
          timer = setInterval(function () {
            show(i + 1);
          }, seconds * 1000);
        } else root.classList.add('is-held');
      };
      var go = function (n) {
        show(n);
        play();
      };
      var prev = root.querySelector('[data-gh-slide-prev]');
      var next = root.querySelector('[data-gh-slide-next]');
      if (prev) prev.addEventListener('click', function () { go(i - 1); });
      if (next) next.addEventListener('click', function () { go(i + 1); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { go(Number(d.getAttribute('data-gh-slide-dot'))); });
      });
      // pause while the pointer is on the photo controls (not on the whole hero, or it would never move)
      var pauseEl = root.querySelector('.gh-hero__media, .gh-hero2__tabs, .gh-hero2__spot') || root;
      var media = root.querySelector('.gh-hero__media, .gh-hero2__stage') || root;
      pauseEl.addEventListener('mouseenter', function () { hold = true; play(); });
      pauseEl.addEventListener('mouseleave', function () { hold = false; play(); });
      root.addEventListener('focusin', function () { hold = true; play(); });
      root.addEventListener('focusout', function () { hold = false; play(); });
      var x0 = null;
      media.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      media.addEventListener('touchend', function (e) {
        if (x0 == null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
        x0 = null;
      });
      document.addEventListener('visibilitychange', play);
      show(0);
      play();
    });
  }

  /* hero heading: the last words change by themselves (your size, your shape, your design) */
  function rotatingWords() {
    document.querySelectorAll('[data-gh-words]').forEach(function (box) {
      if (box.ghWords) return;
      box.ghWords = true;
      var words = Array.prototype.slice.call(box.children);
      if (words.length < 2 || still) return;
      var i = 0;
      // the box keeps the width of the longest word, so nothing beside it moves
      var widest = 0;
      words.forEach(function (w) {
        widest = Math.max(widest, w.getBoundingClientRect().width);
      });
      box.style.minWidth = Math.ceil(widest) + 'px';
      setInterval(function () {
        if (document.hidden) return;
        var cur = words[i];
        i = (i + 1) % words.length;
        var next = words[i];
        cur.classList.remove('is-on');
        cur.classList.add('is-off');
        cur.setAttribute('aria-hidden', 'true');
        next.classList.remove('is-off');
        next.classList.add('is-on');
        next.removeAttribute('aria-hidden');
        setTimeout(function () {
          cur.classList.remove('is-off');
        }, 700);
      }, 2600);
    });
  }

  /* product cards: a small live mirror that lights up on hover */
  function cards() {
    document.querySelectorAll('[data-gh-card-mirror]').forEach(function (canvas) {
      if (canvas.ghMirror || !window.GHMirror) return;
      var d = canvas.dataset;
      var m = new window.GHMirror(canvas, {
        kind: d.kind || 'rectangle',
        w: Number(d.w) || 24,
        h: Number(d.h) || 36,
        led: d.led === 'true',
        lit: false,
        dims: false,
        border: Number(d.border) || 0,
        printArea: d.border && Number(d.border) ? 'border' : 'none',
        colors: GH.colors || {},
      });
      canvas.ghMirror = m;
      var card = canvas.closest('.gh-card');
      if (card && d.led === 'true') {
        card.addEventListener('mouseenter', function () {
          m.set({ lit: true });
        });
        card.addEventListener('mouseleave', function () {
          m.set({ lit: false });
        });
      }
    });
  }

  function start() {
    sliders();
    rotatingWords();
    cards();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
